import React, { useState } from "react";

const CalculadorTiempo = () => {
  const [horaInicio, setHoraInicio] = useState("08:00");
  const [horaFin, setHoraFin] = useState("17:00");
  const [resultado, setResultado] = useState("");
  const [error, setError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const calcularTiempo = () => {
    setError("");
    setResultado("");

    if (!horaInicio || !horaFin) {
      setError("Por favor, ingresa ambas horas");
      return;
    }

    try {
      const [horaIni, minutoIni] = horaInicio.split(":").map(Number);
      const [horaFinVal, minutoFin] = horaFin.split(":").map(Number);

      if (
        isNaN(horaIni) ||
        isNaN(minutoIni) ||
        isNaN(horaFinVal) ||
        isNaN(minutoFin)
      ) {
        setError("Formato de hora inválido. Usa HH:MM");
        return;
      }

      if (
        horaIni < 0 ||
        horaIni > 23 ||
        minutoIni < 0 ||
        minutoIni > 59 ||
        horaFinVal < 0 ||
        horaFinVal > 23 ||
        minutoFin < 0 ||
        minutoFin > 59
      ) {
        setError("Horas deben estar entre 00:00 y 23:59");
        return;
      }

      const minutosInicio = horaIni * 60 + minutoIni;
      const minutosFin = horaFinVal * 60 + minutoFin;

      if (minutosFin <= minutosInicio) {
        setError("La hora final debe ser mayor que la hora inicial");
        return;
      }

      const diferenciaMinutos = minutosFin - minutosInicio;
      const horas = Math.floor(diferenciaMinutos / 60);
      const minutos = diferenciaMinutos % 60;

      let resultadoTexto = `${horas} hora${horas !== 1 ? "s" : ""}`;
      if (minutos > 0) {
        resultadoTexto += ` y ${minutos} minuto${minutos !== 1 ? "s" : ""}`;
      }

      setResultado(resultadoTexto);
    } catch (error) {
      setError("Error al calcular el tiempo. Verifica el formato.");
    }
  };

  const limpiarCampos = () => {
    setHoraInicio("08:00");
    setHoraFin("17:00");
    setResultado("");
    setError("");
  };

  const openModal = () => {
    setIsModalOpen(true);
    limpiarCampos();
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleModalContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <>
      <a
        href="#calculador-tiempo"
        onClick={openModal}
        className="cursor-pointer inline-flex items-center text-gray-400"
      >
        Calculadora lapsos de Tiempo
      </a>

      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 animate-fadeIn"
          onClick={closeModal}
        >
          <div
            className="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 animate-scaleIn"
            onClick={handleModalContentClick}
          >
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h2 className="text-2xl font-bold text-gray-800">
                Calculador de Tiempo
              </h2>
              <button
                onClick={closeModal}
                className="text-gray-400 hover:text-gray-600 transition-colors duration-200 text-2xl"
              >
                ×
              </button>
            </div>

            <div className="p-6">
              <div className="flex flex-col sm:flex-row gap-4 mb-6 text-blue-600 ">
                <div className="flex-1">
                  <label
                    htmlFor="hora-inicio"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Hora de Inicio:
                  </label>
                  <input
                    type="time"
                    id="hora-inicio"
                    value={horaInicio}
                    onChange={(e) => setHoraInicio(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div className="flex-1">
                  <label
                    htmlFor="hora-fin"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Hora de Fin:
                  </label>
                  <input
                    type="time"
                    id="hora-fin"
                    value={horaFin}
                    onChange={(e) => setHoraFin(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>

              <div className="flex gap-3 mb-6 justify-center">
                <button
                  onClick={calcularTiempo}
                  className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors"
                >
                  Calcular
                </button>
                <button
                  onClick={limpiarCampos}
                  className="px-6 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
                >
                  Limpiar
                </button>
              </div>

              {error && (
                <div className="mb-4 p-3 bg-red-100 border border-red-300 text-red-700 rounded-md">
                  ⚠️ {error}
                </div>
              )}

              {resultado && (
                <div className="p-4 bg-green-100 border border-green-300 rounded-md">
                  <h3 className="text-lg font-semibold text-green-800 mb-2">
                    Resultado:
                  </h3>
                  <p className="text-green-700">
                    Tiempo transcurrido:{" "}
                    <strong className="text-green-900">{resultado}</strong>
                  </p>
                  <p className="text-green-700 mt-2">
                    Total en minutos:{" "}
                    <strong className="text-green-900">
                      {parseInt(horaFin.split(":")[0]) * 60 +
                        parseInt(horaFin.split(":")[1]) -
                        (parseInt(horaInicio.split(":")[0]) * 60 +
                          parseInt(horaInicio.split(":")[1]))}{" "}
                      minutos
                    </strong>
                  </p>
                </div>
              )}
            </div>

            <div className="flex justify-end p-6 border-t border-gray-200 bg-gray-50 rounded-b-xl">
              <button
                onClick={closeModal}
                className="px-6 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CalculadorTiempo;
